export interface IConfigurationState {
    configuration: IConfigurationResponse;
    isPartnerConfigLoading: boolean;
    redirectToDashboard: boolean;
    childAccountSwitchRedirectURL: string;
    countryList?: ICountryList[];
    redirectToken?: string;
    partnerLanguageOptions?: IPartnerLanguageOption[];
    loading?: boolean;
    cid: string;
    channel: string;
    isPartnerConfigDataLoading: boolean;
    salesTax: number;
    annualTax: number;
}

export const REQUEST_CONFIGURATION = "REQUEST_CONFIGURATION";
export const RECEIVE_CONFIGURATION = "RECEIVE_CONFIGURATION";
export const RECEIVE_CONFIGURATION_LOADER = "RECEIVE_CONFIGURATION_LOADER";
export const GET_COUNTRY_LIST = "GET_COUNTRY_LIST";
export const SET_REDIRECT_TO_DASHBOARD = "SET_REDIRECT_TO_DASHBOARD";
export const SET_CHILD_ACCOUNT_SWITCH_REDIRECT_URL = "SET_CHILD_ACCOUNT_SWITCH_REDIRECT_URL";
export const REDIRECT_TOKEN_URL = "REDIRECT_TOKEN_URL";
export const SET_LANGUAGE_OPTIONS = "SET_LANGUAGE_OPTIONS";
export const SET_ROUTE_LOADING = "SET_ROUTE_LOADING";
export const SET_CID_UNPAID_CHANNEL_DATA = "SET_CID_UNPAID_CHANNEL_DATA";
export const RECEIVE_CONFIGURATION_DATA_LOADER = "RECEIVE_CONFIGURATION_DATA_LOADER";
export const SET_SALES_TAX_DATA = "SET_SALES_TAX_DATA";

export interface IRequestConfigurationAction {
    type: typeof REQUEST_CONFIGURATION;
}

export interface IReceiveConfigurationAction {
    type: typeof RECEIVE_CONFIGURATION;
    configuration: IConfigurationResponse;
}

export interface IRedirectToDashboard {
    type: typeof SET_REDIRECT_TO_DASHBOARD;
    redirectToDashboard: boolean;
}

export interface IChildAccoutSwitchRedirectUrlAction {
    type: typeof SET_CHILD_ACCOUNT_SWITCH_REDIRECT_URL;
    childAccountSwitchRedirectURL: string;
}

export interface IReceiveConfigurationLoaderAction {
    type: typeof RECEIVE_CONFIGURATION_LOADER;
    isPartnerConfigLoading: boolean;
}

export interface ICountryListAction {
    type: typeof GET_COUNTRY_LIST;
    countryList: ICountryList[];
}
export interface IRedirectTokenUrl {
    type: "REDIRECT_TOKEN_URL";
    redirectToken: string;
}
export interface IPartnerLanguageOptions {
    type: "SET_LANGUAGE_OPTIONS";
    partnerLanguageOptions: IPartnerLanguageOption[];
}
export interface ISetRouteLoading {
    type: "SET_ROUTE_LOADING";
    loading: boolean;
}
export interface ISetUnpaidCidData {
    type: "SET_CID_UNPAID_CHANNEL_DATA";
    cid: string;
    channel: string;
}
export interface IReceiveConfigurationDataLoaderAction {
    type: typeof RECEIVE_CONFIGURATION_DATA_LOADER;
    isPartnerConfigDataLoading: boolean;
}
export interface ISetSalesTaxData {
    type: "SET_SALES_TAX_DATA";
    salesTax: number;
    annualTax: number;
}

export type ConfigurationTypes =
    | IChildAccoutSwitchRedirectUrlAction
    | IRedirectToDashboard
    | IRequestConfigurationAction
    | IReceiveConfigurationAction
    | IReceiveConfigurationLoaderAction
    | ICountryListAction
    | IRedirectTokenUrl
    | IPartnerLanguageOptions
    | ISetRouteLoading
    | ISetUnpaidCidData
    | IReceiveConfigurationDataLoaderAction
    | ISetSalesTaxData;

export interface IConfigurationResponse {
    recaptchaSiteKey: string;
    idfLoginURL: string;
    partnerConfig: IPartnerConfig;
    countryList?: ICountryList[];
    userAuthStatus?: string;
}

export interface ISsoOptions {
    allowChangePassword: boolean;
    redirectToAuthProvider: boolean;
    clientId?: string;
    logoutURL?: string;
    allowRegistrationFlow?: boolean;
    disableEmailOnMyAccountScreen?: boolean;
    displayEmailUnderMyAccountPreference?: boolean;
    externalHostUrl?: string;
    showCustomErrorPage: boolean;
    forcePasswordResetForSSOUser: boolean;
}
export interface IPartnerConfig {
    partnerProvider?: string;
    hasError?: boolean;
    errors?: string[];
    brandingOption?: IBrandingOption;
    allowPackageUpgrade?: boolean;
    allowAppDownLoad?: boolean;
    hasEducationAndBreach?: boolean;
    isWhiteLabeled?: boolean;
    termsAndCondtionsUpdated?: boolean;
    legalName?: string;
    navigationTop?: boolean;
    renderInIframe?: boolean;
    email?: string;
    phoneNumber?: string;
    footerLogoHTML?: string;
    isEnrollmentAvailable?: boolean;
    isFrenchOnlyPartner?: boolean;
    isWalkupEnrollAvailable?: boolean;
    originSiteUrl?: string;
    enrollNowPath?: string;
    styleSheetSrc?: string;
    partnerId?: number;
    supportInternational?: boolean;
    internationalPhoneNumber?: string;
    businessPhoneNumber?: string;
    retailerPhoneNumber?: string;
    retailerCyberClaimPhoneNumber?: string;
    isSpeakWithAgentOnPackagePageVisible?: boolean;
    bannerTextOnPackagePage?: string;
    retailerName?: string;
    partnerDisplayName?: string;
    hasSontiqBrand?: string;
    faviconURL?: string;
    termsOfUseLegalDocumentLink?: string;
    privacyPolicyLegalDocumentLink?: string;
    doNotSellMyInformationLegalDocumentLink?: string;
    isIdfPartner?: boolean;
    isIDFTemplate?: boolean;
    liveAgentLabel?: string;
    liveAgentPhoneNumber?: string;
    commonDefinitionLegalDocumentLink?: string;
    partnerModes?: string[];
    isPasswordsAvailable?: boolean;
    privacyPolicyUpdated?: boolean;
    eUUSPrivacyPolicyUpdated?: boolean;
    eUGDPRUpdated?: boolean;
    allowLoginWithUserName?: boolean;
    termsOfUseLegalDocumentLabel?: string;
    privacyPolicyLegalDocumentLabel?: string;
    doNotSellMyInformationLabel?: string;
    trustCenterLegalDocumentLink?: string;
    ssoOptions?: ISsoOptions;
    isShowSocialMediaLinks?: boolean;
    isShowSocialConnectUsOnlineModule?: boolean;
    isHideCommonDefinitions?: boolean;
    registration?: IRegistration;
    includeLogoOnInternalScreens?: boolean;
    defaultCountryCode?: string;
    termsContent?: string;
    renderInWebView?: boolean;
    bookmarkLoginText?: string;
    retailerCode?: string;
    isBillingSectionHide?: boolean;
    partnerL3DisclaimerText?: string;
    partnerSSOOptionTNCText?: string;
    hideChangePlan?: boolean;
    retailerTollFreeNumber?: string;
    retailerDefaultBillingCycle?: string;
    personalInformationLabel?: string;
    personalInformationLink?: string;
    isDynamicFooterAvailable?: boolean;
    isRetailerPhoneNumberHide?: boolean;
}

export interface IBrandingOption {
    imagePath?: string;
    secondaryLogo: string;
    imageName: string;
    associationText: string;
    secondaryText: string;
    externalImagePath: string;
}
export interface ICountryList {
    name: string;
    countryCode: string;
    countryID: number;
    countryCallingCode: number;
    requiresZipCode: boolean;
}

export interface IPartnerLanguageOption {
    code: string;
    description: string;
    displayName: string;
    id: number;
    name: string;
}

export interface IRegistration {
    showTermsAndConditionScreenFirst: boolean;
    includePartnerLogo: boolean;
    hideTripleLayerDefense: boolean;
}
